import React, { ChangeEvent } from 'react';
import FormControl from '@mui/material/FormControl';
import { IDnsState, ISimState } from '@core/interfaces/ISettings';
import { BindedHandler } from '@core/interfaces/binded-handler';
import InputComponent from '@ui/components/Input/Input.component';
import useDictionary from '@ui/hooks/useDictionary';
import SimItemComponent from './Sim-item.component';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    dnsAddress: IDnsState<string>;
    simApn: ISimState<string>;
    simLogin: ISimState<string>;
    simPassword: ISimState<string>;
    onDnsAddressChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onSimApnChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onSimLoginChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onSimPasswordChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onInputClick: () => void;
}

const Component: React.FC<IProps> = ({
    lang,
    dnsAddress,
    simApn,
    simLogin,
    simPassword,
    onDnsAddressChange,
    onSimApnChange,
    onSimLoginChange,
    onSimPasswordChange,
    onInputClick,
}: IProps) => {
    const getWord = useDictionary();
    const simItems = Object.keys(simApn).map((sim) => (
        <SimItemComponent
            key={sim}
            lang={lang}
            sim={sim}
            simApn={simApn[sim as keyof typeof simApn] ?? ''}
            simLogin={simLogin[sim as keyof typeof simLogin] ?? ''}
            simPassword={simPassword[sim as keyof typeof simPassword] ?? ''}
            onSimApnChange={onSimApnChange}
            onSimLoginChange={onSimLoginChange}
            onSimPasswordChange={onSimPasswordChange}
            onInputClick={onInputClick}
        />
    ));
    const dnsItems = Object.keys(dnsAddress).map((dns) => (
        <InputComponent
            label={`${getWord('dnsAddress')} №${dns.split('dns')[1]}`}
            name={dns}
            type="text"
            lang={lang}
            description={`${getWord('dnsAddressTooltip')} №${
                dns.split('dns')[1]
            }`}
            value={dnsAddress[dns as keyof typeof dnsAddress]}
            onChange={onDnsAddressChange.bind(this, dns)}
            onClick={onInputClick}
            onFocus={onInputClick}
        />
    ));

    return (
        <FormControl className="device-settings__form" component="form">
            {dnsItems}
            {simItems}
        </FormControl>
    );
};

const InternetAccessSettingsComponent = React.memo(Component);

export default InternetAccessSettingsComponent;
